import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { ViewForSiderFieldsFragment, ViewGroupFieldsFragment } from '@salescore/client-api'
import {
  convertFlatViewGroupsToAntdTree,
  type ExpandedAntdNodeSerializable,
  serializeExpandedAntdNode,
} from '@salescore/client-common'
import { Array, Filter } from 'effect'

interface ViewGroupForestState {
  viewGroupTree: ExpandedAntdNodeSerializable[]
  privateViewGroupTree: ExpandedAntdNodeSerializable[]
  archivedViewGroupTree: ExpandedAntdNodeSerializable[]
}

const initialState: ViewGroupForestState = {
  viewGroupTree: [],
  privateViewGroupTree: [],
  archivedViewGroupTree: [],
}

export const viewGroupForestSlice = createSlice({
  name: 'viewGroupForest',
  initialState,
  reducers: {
    setViewGroupTree: (state, action: PayloadAction<ExpandedAntdNodeSerializable[]>) => {
      // eslint-disable-next-line no-param-reassign
      state.viewGroupTree = serializeExpandedAntdNode(action.payload)
    },
    setPrivateViewGroupTree: (state, action: PayloadAction<ExpandedAntdNodeSerializable[]>) => {
      // eslint-disable-next-line no-param-reassign
      state.privateViewGroupTree = serializeExpandedAntdNode(action.payload)
    },
    refreshViewGroupForest: (
      state,
      action: PayloadAction<{
        views: ViewForSiderFieldsFragment[]
        viewGroups: ViewGroupFieldsFragment[]
      }>,
    ) => {
      const { views, viewGroups } = action.payload
      const [privateViews, publicViews] = Array.partition(
        views,
        Filter.fromPredicate((x) => x.private),
      )
      const [privateViewGroups, publicViewGroups] = Array.partition(
        viewGroups,
        Filter.fromPredicate((x) => x.private),
      )
      const [archivedViews, publicActiveViews] = Array.partition(
        publicViews,
        Filter.fromPredicate((x) => x.archived),
      )
      const [archivedViewGroups, publicActiveViewGroups] = Array.partition(
        publicViewGroups,
        Filter.fromPredicate((x) => x.archived),
      )
      // eslint-disable-next-line no-param-reassign
      state.viewGroupTree = convertFlatViewGroupsToAntdTree(publicActiveViewGroups, publicActiveViews)
      // eslint-disable-next-line no-param-reassign
      state.privateViewGroupTree = convertFlatViewGroupsToAntdTree(privateViewGroups, privateViews)
      // eslint-disable-next-line no-param-reassign
      state.archivedViewGroupTree = convertFlatViewGroupsToAntdTree(archivedViewGroups, archivedViews)
    },
  },
  selectors: {},
})

export const { setViewGroupTree, setPrivateViewGroupTree, refreshViewGroupForest } = viewGroupForestSlice.actions
export default viewGroupForestSlice.reducer
